import { ButtonProps, Button as FlowBiteButton } from 'flowbite-react';
import React, { useImperativeHandle, useRef } from 'react';
import { twMerge } from 'tailwind-merge';

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(({ id, className = '', ...props }, ref) => {
  const e = useRef<HTMLButtonElement>({} as HTMLButtonElement);

  useImperativeHandle(ref, () => e.current);

  return (
    <FlowBiteButton
      {...props}
      id={id}
      ref={e}
      className={twMerge(
        'rounded-md border-gray-500 text-black disabled:border-slate-300 disabled:bg-slate-200 disabled:text-slate-400 disabled:opacity-100',
        className,
      )}
    />
  );
});
